<template>
    <div class="content-side content-side-full">
        <ul class="nav-main">
        <li>
            <router-link :to="{name: 'dashboard'}">
            <i class="si si-cup"></i> <span>Dashboard</span>
            </router-link>
        </li>

        <!-- <li>
            <router-link :to="{name: 'checkout'}">
            <i class="si si-wallet"></i> <span>Showroom order</span>
            </router-link>
        </li> -->

        <li class="nav-main-heading">
            <span>Orderafhandeling</span>
        </li>
        <li>
            <router-link :to="{name: 'orders'}">
            <i class="si si-basket"></i> <span>Bestellingen</span>
            </router-link>
            <router-link :to="{name: 'refunds'}">
            <i class="si si-control-rewind"></i> <span>Retouren</span>
            </router-link>
        </li>

        <li class="nav-main-heading">
            <span>Magazijn</span>
        </li>
        <li>
            <router-link :to="{name: 'products'}">
            <i class="si si-tag"></i> <span>Producten</span>
            </router-link>
        </li>
        <!-- <li>
            <router-link :to="{name: 'stock_value'}">
            <i class="si si-tag"></i> <span>Voorraadwaarde</span>
            </router-link>
        </li>
        <li>
            <router-link :to="{name: 'stock_management'}">
            <i class="si si-tag"></i> <span>VooraadManagement</span>
            </router-link>
        </li> -->
        <li>
            <router-link :to="{name: 'unknown_products'}">
            <i class="si si-tag"></i> <span v-if="amountUnknownProducts"> <i class="fa fa-exclamation-circle fa-lg text-danger"></i> {{amountUnknownProducts}} Onbekende producten </span> <span v-else>Onbekende producten</span>
            </router-link>
        </li>

        <li class="nav-main-heading">
            <span>Inkooporders</span>
        </li>

         <li>
            <router-link :to="{name: 'order_lists'}">
            <i class="si si-tag"></i> <span>Inkooporders</span>
            </router-link>
        </li>

        <li class="nav-main-heading">
            <span>Medewerkers</span>
        </li>

        <li>
            <router-link :to="{name: 'users'}">
            <i class="si si-people"></i> <span>Gebruikers</span>
            </router-link>
        </li>

        <li class="nav-main-heading">
            <span>Systeem</span>
        </li>
        <li>
            <router-link :to="{name: 'sales-channels'}">
            <i class="si si-share"></i> <span>Verkoopkanalen</span>
            </router-link>
        </li>
        <li>
            <router-link :to="{name: 'dropshipment'}">
            <i class="si si-share"></i> <span>Dropshipment</span>
            </router-link>
        </li>
        <li>
            <router-link :to="{name: 'settings'}">
            <i class="si si-wrench"></i> <span>Instellingen</span>
            </router-link>
        </li>

        <li class="nav-main-heading">
            <span>Rapportage</span>
        </li>
        <li>
            <router-link :to="{name: 'report_purchasing_value_orders'}">
            <i class="si si-bar-chart"></i> <span>Winstgevendheid</span>
            </router-link>
        </li>
        <li>
            <router-link :to="{name: 'report_profit_margins'}">
            <i class="si si-bar-chart"></i> <span>Product winstgevendheid</span>
            </router-link>
        </li>
        <li>
            <router-link :to="{name: 'report_revenue'}">
            <i class="si si-bar-chart"></i> <span>Omzet</span>
            </router-link>
        </li>
        <li>
            <router-link :to="{name: 'report_products'}">
            <i class="si si-bar-chart"></i> <span>Producten</span>
            </router-link>
        </li>
        </ul>
    </div>
</template>
<script>
import http from '../../utils/http'
export default {
  data () {
    return {
      amountUnknownProducts: null
    }
  },
  methods: {
    loadUnknownProducts () {
      http.get(`/products-unknown-count`)
        .then((result) => {
          if (result.data > 0) {
            this.amountUnknownProducts = result.data
          }
        })
        .catch(() => {
        })
    }
  },
  created () {
    this.loadUnknownProducts()
  }
}
</script>




// WEBPACK FOOTER //
// AdminSidebar.vue?63270841